"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var theme = require("./theme.scss");
var _ = require("lodash");
var ui_1 = require("@vidazoo/ui");
exports.renderJSONValue = function (data) { return (React.createElement(ui_1.NativeScrollable, { className: theme.codeScrollArea },
    React.createElement("pre", { className: theme.code }, JSON.stringify(data, undefined, 2)))); };
exports.renderStringValue = function (value) { return "\"" + value.toString() + "\""; };
exports.flattenValue = function (data) { return !_.isUndefined(data) && !_.isNull(data)
    ? typeof data === "object"
        ? exports.renderJSONValue(data)
        : exports.renderStringValue(data)
    : ""; };
exports.renderValueSnapshot = function (value) { return React.createElement("span", { className: theme.value }, exports.flattenValue(value)); };
